import { axios } from '@Root/API'

export const get = params => {
	return axios.get('data-pruning/contact', { params })
}
